

import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col  } from 'reactstrap';
import { MOBILE_API_DOCUMENTATION,MOBILE_API_DOCUMENTATION_V2 } from 'redux/lib/constants/api-urls';
import MainComponent from './main-component';

const MobileApiDocumentation = (props) => {

    const [activeTab, setActiveTab] = React.useState('V2');

    const handleTab = (tab) => {
        setActiveTab(tab)
    }

    return (
        <Row>
            <Col sm="12" lg="12">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={(activeTab === 'V1') ? 'active' : ''}
                            onClick={() => handleTab('V1')} >
                            Version 1.0.0
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(activeTab === 'V2') ? 'active' : ''}
                            onClick={() => handleTab('V2')} >
                            Version 2.0.0
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} style={{ paddingTop: 30 }}>
                    <TabPane tabId="V1">
                        <MainComponent url={`${MOBILE_API_DOCUMENTATION.URL}`} />
                    </TabPane>
                    <TabPane tabId="V2">
                        <MainComponent url={`${MOBILE_API_DOCUMENTATION_V2.URL}`} /> 
                    </TabPane>
                </TabContent>
            </Col>

        </Row>

    );
};
export default MobileApiDocumentation;


